import React from 'react'
import LibraryComponent from '../../../components/library/library-no-modal'
import HelperModal from './helper-modal'
import ModalManager from '../../components/modal/modal-manager'

const HelperList = ({ helpers }) => {
    const handleItemSelect = item => {
        if (item.id === 2) {
            window.open('https://www.google.cn/intl/zh-CN/chrome/', '_blank');
            return
        }
        if (item.id === 3) {
            window.open(window.config.clientURL, '_blank');
            return
        }
        ModalManager.open(HelperModal, {
            onClose: () => { },
            coverItem: item,
            coverUrl: item.rawUrl,
            videoUrl: item.videoUrl,
            title: item.name
        })
    }
    const items = helpers.map(item => ({
        id: item.id,
        name: item.name,
        rawURL: item.cover,
        featured: true,
        videoUrl: item.videoUrl
    }))
    return (
        <React.Fragment>
            {/*<img style={{position: "absolute", zIndex:1, left:"18px", top:"21px"}} src={require('./new.png')} />*/}
            <LibraryComponent
                data={items}
                filterable={false}
                id="HelperLibrary"
                title="帮助列表"
                visible={true}
                onItemSelected={handleItemSelect}
            />
        </React.Fragment>
    )
}

export default HelperList
